/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No results on file" |
*
* @param {Meta_Event_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_no_results = /** @type {((inputs?: Meta_Event_No_ResultsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_No_ResultsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ergebnisse hinterlegt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun résultat enregistré")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("没有成绩记录")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("沒有成績紀錄")
	if (locale === "ko") return /** @type {LocalizedString} */ ("기록된 결과 없음")
	return /** @type {LocalizedString} */ ("No results on file")
});